import { QueryClient } from '@tanstack/react-query'

const ONE_HOUR = 60 * 60 * 1000
const FOUR_HOURS = 4 * ONE_HOUR
const DEFAULT_STALE_TIME = ONE_HOUR // 1 hour
const DEFAULT_GC_TIME = FOUR_HOURS // 4 hours
const IS_TEST = process.env.NODE_ENV === 'test'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: IS_TEST ? 0 : DEFAULT_STALE_TIME,
      gcTime: IS_TEST ? 0 : DEFAULT_GC_TIME,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (count, err: any) => {
        const status = err?.response?.status
        return !(status >= 400 && status < 500) && count < 2
      }
    },
    mutations: { retry: 0 }
  }
})
